<template>
  <div>
    <div class="vx-card p-6">
      <div class="flex flex-wrap" style="font-size: 40px; justify-content: center;">
        PERSONEL İZİN YÖNETİMİ
      </div>

      <div class="vx-row mt-5">
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Durum</b></label>
          <v-select @input="getPermissions()" class="w-full" placeholder="Durum" label="statusName" :options="statusList" v-model="searchModel.status" :reduce="(row) => row.status">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>

        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Personel</b></label>
          <v-select @input="getPermissions()" class="w-full" placeholder="Form Oluşturan" label="userName" :options="personnalList" v-model="searchModel.userId" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Başlangıç</b></label>
          <vs-input type="date" class="w-full" size="medium" v-model="searchModel.startDate"></vs-input>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm"><b>Bitiş</b></label>
          <vs-input @change="getPermissions()" type="date" class="w-full" size="medium" v-model="searchModel.finishDate"></vs-input>
        </div>

        <div class="vx-col md:w-1/5 w-full justify-end flex">
          <div class="vx-row">
            <div class="flex flex-wrap items-center">
              <div class="flex-grow"></div>
              <div class="vx-col md:w-1/2">
                <div style="cursor: pointer; width: 100px; margin-top: 10px;" class="px-4 py-1 flex items-center">
                  <feather-icon svgClasses="w-6 h-6" icon="DownloadIcon" class="mr-2" />
                  <JsonExcel :data="permissionList" class><b>İndir</b></JsonExcel>
                </div>
              </div>
              <div class="vx-col md:w-1/2">
                <div class="vx-row">
                  <div class="vx-col ml-5">
                    <vs-button style="margin-top: 10px;" @click.stop="getPermissions()">Ara</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="margin-top: 20px;">
        <vs-divider />
        <!-- prompt for addnew personnel -->

        <!-- AgGrid Table -->

        <ag-grid-vue
          style="height: 60vh;"
          ref="agGridTable"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 mx-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="permissionList"
          rowSelection="single"
          colResizeDefault="shift"
          :animateRows="true"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :rowClassRules="rowClassRules"
          :context="context"
        ></ag-grid-vue>

        <vs-pagination :total="totalPages" :max="10" v-model="currentPage" />
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";
import JsonExcel from "vue-json-excel";

// Cell Renderer

export default {
  components: {
    vSelect,
    AgGridVue,
    JsonExcel,
  },
  data() {
    return {
      personnalList: [],
      permissionList: [],
      filterList:[],
      statusList: [
        { status: "T", statusName: "Onay Bekleyen" },
        { status: "O", statusName: "Onaylanmış" },
        { status: "R", statusName: "Reddedilmiş" },
      ],
      searchModel: { startDate: null, finishDate: null, status: null, userId: null },
      delayedSearchTimer: "",
      gridApi: null,
      rowClassRules: null,

      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "Form Id",
          field: "permissionId",
          filter: true,
          width: 100,
        },

        {
          headerName: "Personel",
          field: "userName",
          filter: true,
          width: 150,
        },

        {
          headerName: "Durum",
          field: "statusName",
          filter: true,
          width: 150,
        },
        {
          headerName: "Başlangıç Tarihi",
          field: "startDate",
          filter: true,
          width: 150,
        },
        {
          headerName: "Bitiş Tarihi",
          field: "finishDate",
          filter: true,
          width: 150,
        },
        {
          headerName: "Onaylayan",
          field: "firstApproverName",
          filter: true,
          width: 100,
        },
        {
          headerName: "Gün",
          field: "day",
          filter: true,
          width: 100,
        },

        {
          headerName: "Açıklama",
          field: "description",
          filter: true,
          width: 200,
        },
      ],
    };
  },

  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  created() {
    this.getUsers();
    this.getPermissions();
  },
  methods: {
    getUsers: async function () {
      await repository.getAll("User/getUserList").then((r) => {
        this.personnalList = r.list;
      });

      return this.personnalList;
    },
    getPermissions: async function () {
      this.permissionList = await repository.postEntity("HumanResource/GetPermission", this.searchModel).then((r) => r.list);
      for (let i = 0; i < this.permissionList.length; i++) {
      this.permissionList[i].startDate = this.permissionList[i].startDate.substr(0, 10);
      this.permissionList[i].finishDate = this.permissionList[i].finishDate.substr(0, 10);
      }
      console.log("wsq",this.permissionList)
      return this.permissionList;
    },
  },

  beforeMount() {
    this.rowClassRules = {};
    this.context = { componentParent: this };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();
  },
};
</script>

<style lang="scss" scoped></style>
